import React from "react";
import { IoMenu, IoCloseSharp } from "react-icons/io5";
import MenuLinks from "../../molecules/layout/MenuLinks";
import useModal from "../../../hooks/useModal";

const Sidebar = () => {
    const { open: openSide, close: closeSide, isOpen: isOpenSide } = useModal();

    return (
        <div className="">
        {!isOpenSide &&
            <button className="fixed md:hidden top-20 left-1 z-50 bg-rs-azul/65 rounded-full" onClick={openSide}>
                <IoMenu className="text-white" size={40} />
            </button>
        }
        {isOpenSide &&
            <div className="fixed flex flex-row w-full text-white h-full z-30">
                <div className="w-2/3 bg-gradient-to-b from-indigo-100 via-gray-400 to-indigo-800 overflow-auto py-6">
                    <MenuLinks onClose={closeSide}/>
                </div>
                <div className="w-1/3 flex bg-black bg-opacity-50 justify-center p-4 pt-10">
                    <button className="h-10 w-10 bg-rs-rojo rounded-full" onClick={closeSide}>
                        <IoCloseSharp className="text-white" size={40} />
                    </button>
                </div>
            </div>
        }
        <div className="hidden md:block w-40 h-full z-30 pt-6 pb-4 overflow-none">
            <MenuLinks/>
            </div>
        </div>
    );
};

export default Sidebar;